namespace TabAurous.ProductDevelopment {
    export namespace RequirementSelectItemsService {
        export const baseUrl = 'ProductDevelopment/RequirementSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/RequirementSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>RequirementSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
